import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  private messageSource = new BehaviorSubject<any>("");
  currentMessage = this.messageSource.asObservable();

  private dataSource = new BehaviorSubject<any>({});
  currentData = this.dataSource.asObservable();

  private scrollSource = new BehaviorSubject<any>("");
  isPreventScroll = this.scrollSource.asObservable();

  private popupSource = new BehaviorSubject<any>("");
  popupData = this.popupSource.asObservable();

  private visitSource = new BehaviorSubject<any>("");
  visitData = this.visitSource.asObservable();

  private transferSource = new BehaviorSubject<any>("");
  transferData = this.transferSource.asObservable();

  private paymentSource = new BehaviorSubject<any>("");
  paymentData = this.paymentSource.asObservable();

  private companySource = new BehaviorSubject<any>("");
  companyData = this.companySource.asObservable();

  private accountSource = new BehaviorSubject<any>("");
  accountData = this.accountSource.asObservable();

  private approvalSource = new BehaviorSubject<any>("");
  approvalData = this.approvalSource.asObservable();

  private depositaccountType = new BehaviorSubject<any>("");
  depositaccountData = this.depositaccountType.asObservable();

  private approverTypeSource = new BehaviorSubject<any>("");
  approverTypeData = this.approverTypeSource.asObservable();

  private ownerAccountNoSource = new BehaviorSubject<any>("");
  ownerAccountNoData = this.ownerAccountNoSource.asObservable();

  private noticeCountSource = new BehaviorSubject<any>(0);
  noticeCountData = this.noticeCountSource.asObservable();

  private OursNameSource = new BehaviorSubject<any>("");
  OursNameData = this.OursNameSource.asObservable();

  private imageSource = new BehaviorSubject<any>("");
  imageData = this.imageSource.asObservable();

  private favoriteMenuSource = new BehaviorSubject<any>("");
  favoriteMenuData = this.favoriteMenuSource.asObservable();

  private favoriteMenuListSource = new BehaviorSubject<any>([]);
  favoriteMenuListData = this.favoriteMenuListSource.asObservable();

  private inquiryApprovalSource = new BehaviorSubject<any>({});
  inquiryApproval = this.inquiryApprovalSource.asObservable();

  private reloadDirectTransferSource =  new BehaviorSubject<any>([]);
  reloadDirectTransferData = this.reloadDirectTransferSource.asObservable();

  private loadUserGuideSource =  new BehaviorSubject<any>([]);
  loadUserGuideSourceData = this.loadUserGuideSource.asObservable();

  private mainPub = {};
  private mainSub = {};

  constructor() {}

  publish(key: string, value) {
      if (this.mainPub[key]) {
        this.mainPub[key].next(value);
        return;
      }
      this.mainPub[key] = new BehaviorSubject<any>('');
      this.mainSub[key] = this.mainPub[key].asObservable();
      this.mainPub[key].next(value);
  }

  subscribe(key: string, fn?: (v: any) => void, error?: (e: any) => void) {
    this.mainSub[key].subscribe(v => {
      fn(v);
      this.completeStream(key);
    }, er => {
      error(er);
      this.completeStream(key);
    });
  }

  completeStream(key: string) {
    this.mainPub[key].complete();
    this.mainPub[key] = null;
    this.mainSub[key] = null;
  }

  channelMessage(message: any) {
    this.messageSource.next(message);
  }

  paramSave(data: any) {
    this.dataSource.next(data);
  }

  scrollMessage(message: any) {
    this.scrollSource.next(message);
  }

  scrollChange(message: any) {
    this.scrollSource.next(message);
  }

  popupMessage(message: any) {
    this.popupSource.next(message);
  }

  addVisitedMenu(message: any) {
    this.visitSource.next(message);
  }

  visitMessage(message: any) {
    this.visitSource.next(message);
  }

  amountMessage(message: any) {
    this.transferSource.next(message);
  }

  changeMessage(message: any) {
    this.paymentSource.next(message);
  }

  companyMessage(message: any) {
    this.companySource.next(message);
  }
  accountMessage(message: any) {
    this.accountSource.next(message);
  }

  approvalStatus(status: any) {
    this.approvalSource.next(status);
  }

  depositType(acctype: any) {
    this.depositaccountType.next(acctype);
  }

  approverType(type: any) {
    this.approverTypeSource.next(type);
  }

  ownerAccountNumber(num: any) {
    this.ownerAccountNoSource.next(num);
  }

  noticeCountMessage(num: number) {
    this.noticeCountSource.next(num);
  }

  oursNameMessage(name: any) {
    this.OursNameSource.next(name);
  }

  imageMessage(userimage: any) {
    this.imageSource.next(userimage);
  }

  favoriteMenuMessage(favmenu: any) {
    this.favoriteMenuSource.next(favmenu);
  }

  favoriteMenuListMessage(favoriteMenuList: any[]) {
    this.favoriteMenuListSource.next(favoriteMenuList);
  }

  inquiryApprovalData(source: {
    approvalStatusCode: string;
    approvalTypeCode: string;
  }) {
    this.inquiryApprovalSource.next(source);
  }

  reloadDirectTransferMessage(flag: boolean) {
    this.reloadDirectTransferSource.next(flag);
  }

  loadUserGuideMessage(source: string) {
    this.loadUserGuideSource.next(source);
  }

  unsubscribe() {
    this.dataSource.complete();
    this.scrollSource.complete();
    this.popupSource.complete();
    this.transferSource.complete();
    this.paymentSource.complete();
    this.approvalSource.complete();
    this.approverTypeSource.complete();
    this.ownerAccountNoSource.complete();
  }
}
